/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Edit_TitleInputs */

const en_us2_gyms_edit_title = /** @type {(inputs: Gyms_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit gym`)
};

const pt_br2_gyms_edit_title = /** @type {(inputs: Gyms_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar academia`)
};

const es_419_gyms_edit_title = /** @type {(inputs: Gyms_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar gimnasio`)
};

const pt_pt2_gyms_edit_title = /** @type {(inputs: Gyms_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar ginásio`)
};

const fr_fr2_gyms_edit_title = /** @type {(inputs: Gyms_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier la salle`)
};

const de_de2_gyms_edit_title = /** @type {(inputs: Gyms_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio bearbeiten`)
};

const it_it2_gyms_edit_title = /** @type {(inputs: Gyms_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica palestra`)
};

/**
* | output |
* | --- |
* | "Edit gym" |
*
* @param {Gyms_Edit_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_edit_title = /** @type {((inputs?: Gyms_Edit_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Edit_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_edit_title(inputs)
	if (locale === "es-419") return es_419_gyms_edit_title(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_edit_title(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_edit_title(inputs)
	if (locale === "de-DE") return de_de2_gyms_edit_title(inputs)
	if (locale === "it-IT") return it_it2_gyms_edit_title(inputs)
	return en_us2_gyms_edit_title(inputs)
});
export { gyms_edit_title as "gyms.edit_title" }